/* eslint-disable no-underscore-dangle */
import fetch from 'node-fetch';

import store from '@/store';
import { getLoginUrl, getToken, clearTokenCookies } from '../utils/auth';

export default async function makeApiRequest (path, method = 'GET', body = {}, signal = null, uploadFiles = false) {
  const params = {
    method: method,
    headers: { Authorization: `Bearer ${getToken()}` },
    body: body,
    signal: signal
  };

  if (!uploadFiles) {
    params.headers['content-Type'] = 'application/json';
    params.body = Object.keys(body).length !== 0 ? JSON.stringify(body) : undefined;
  }

  try {
    const response = await fetch(`${path}`, params);
    // 2. Intercept 401 Unauthorized responses
    if (response.status === 401) {
      // Clear the id_token/CF_Authorization cookies and any chunks
      clearTokenCookies();

      // Clear user from Vuex store
      store.commit('setUser', null);
      store.state.token = null;

      window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);

      return { success: false, message: 'Unauthorized' };
    }

    // Maintenance: our marker header (not a generic 503) — reload onto the wall.
    if (response.status === 503 && response.headers.get('x-maintenance-mode') === 'true') {
      window.location.reload();
      return { success: false, message: 'Maintenance' };
    }

    return response.json();
  } catch (error) {
    console.error('[makeApiRequest] Error => ', JSON.stringify(error, null, 4));
    return { success: false, message: error.message || 'An error occurred' };
  }
}
